<template>
    <b-modal
        :id="modalId"
        title-tag="h2"
        :title="`Delete ` + credit.name"
        :lazy="true"
        ok-title="Proceed"
        @ok="deleteCredit()"
        footer-class="d-flex justify-content-between"
    >
        <span v-if="returnId"
            >Deleting this credit will also delete the related
            {{ selectedMessage }}. Do you wish to delete this credit?</span
        >
        <span v-else-if="paymentId"
            >Deleting this credit will also {{ selectedMessage }} the related
            payment. Do you wish to delete this credit?</span
        >
        <span v-else>Are you sure you want to delete this credit?</span>
    </b-modal>
</template>
<script type="text/javascript">
import BillingServices from "@/services/billing/billing-credit";

export default {
    props: {
        modalId: {
            type: String,
            required: true
        },
        credit: {
            type: Object,
            default() {
                return {};
            }
        },
        isClientPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            paymentId: null,
            returnId: null,
            selectedMessage: null
        };
    },
    watch: {
        credit() {
            this.returnId = this.credit.return_id;
            this.paymentId = this.credit.payment_id;
            if (this.returnId) {
                this.selectedMessage = "return";
                this.selectedMessage = this.credit.refund
                    ? this.credit.refund.amount > 0
                        ? "return item(s)"
                        : this.selectedMessage
                    : this.selectedMessage;
            } else if (this.paymentId) {
                this.selectedMessage = this.credit.cc_processor
                    ? "refund"
                    : "delete";
            }
        }
    },
    methods: {
        deleteCredit() {
            BillingServices.removeCredit(this.credit.id)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.messages);
                        this.$emit("reload");
                    } else {
                        this._message(response.messages, "danger");
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to delete credit", "danger");
                    console.error(error);
                });
        }
    }
};
</script>
